import React from 'react'

const SettingsScreen = () => {
  return (
    <div>SettingsScreen</div>
  )
}

export default SettingsScreen